import React, {Component} from "react";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import SubscriptionService from "../../service/SubscriptionService";
import BotStatusService from "../../service/BotStatusService";
import {FormattedDate, FormattedTime} from "react-intl";

class Builds extends Component {
    constructor() {
        super();

        this.state = {
            rows: []
        }
    }

    componentDidMount() {
        const self = this;

        SubscriptionService.doIfSubscriptionActive(function () {
            BotStatusService.fetchBuildOutcomes((builds) => {
                const rows = [];

                builds.forEach((row) => {
                    rows.push(
                        <tr key={row.id}>
                            <td>{row.job}</td>
                            <td>
                                <i className={`icon ${row.outcome === 'SUCCEEDED' ? 'icon-check' : 'icon-cross'}`}/>
                                {' '}<span className="hidden-xs">{row.outcome}</span>
                            </td>
                            <td>
                                <span className="visible-xs">
                                    <FormattedTime value={row.eventDate}/>
                                    {' '}<FormattedDate value={row.eventDate}
                                                        day="numeric"
                                                        month="numeric"
                                                        year="numeric"/>
                                </span>
                                <span className="hidden-xs">
                                    <FormattedTime value={row.eventDate}/>
                                    {' '}on <FormattedDate value={row.eventDate}
                                                           day="numeric"
                                                           month="long"
                                                           year="numeric"/>
                                </span>
                            </td>
                            <td className="hidden-xs">{row.driver}</td>
                            <td>{row.triggeredBy}</td>
                            <td className="hidden-xs">{row.channel}</td>
                        </tr>
                    )
                });

                self.setState({rows: rows});
            });
        });
    }

    render() {
        return (
            <div>
                <TopNav tab="builds"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 m-b-md">
                                <h1 className="page-header">Build history</h1>
                                <h4 className="text-muted">A record of build and deployment events.</h4>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>Your recent builds are shown below.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="panel panel-info">
                                    <div className="panel-heading"><h3 className="panel-title">Recent Builds</h3></div>
                                    <table className="table table-striped">
                                        <thead>
                                        <tr>
                                            <th>Job</th>
                                            <th><span className="hidden-xs">Outcome</span></th>
                                            <th>When</th>
                                            <th className="hidden-xs">Type</th>
                                            <th>Who</th>
                                            <th className="hidden-xs">Channel</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.rows}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Builds;



// WEBPACK FOOTER //
// ./src/modules/views/bot/Builds.js